import { DocumentNode, gql } from '@apollo/client';

export const TagsQueryWithFiltersGql: DocumentNode = gql`
query TagsQueryWithFilters($first: Int!, $connectionTypeFilter: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean, $isEmbeddedFilter: Boolean, $name: String, $offset: Int!, $textSearch: String) {
  tagsConnection(filter: {text: $name}, first: $first, offset: $offset, orderBy: {field: NAME, direction: ASC}) {
    ...TagsQueryWithFiltersTagsConnection
  }
}

fragment TagsQueryWithFiltersTagsConnection on TagsConnection {
  totalCount
  nodes {
    ...TagsQueryWithFiltersTagsConnectionNodes
  }
}

fragment TagsQueryWithFiltersTagsConnectionNodes on Tag {
  id
  name
  databasesConnection(filter: {connectionType: $connectionTypeFilter, isCertified: $isCertifiedFilter, isEmbedded: $isEmbeddedFilter, hasActiveWarning: $hasActiveWarningFilter, text: $textSearch}) {
    totalCount
  }
  databaseTablesConnection(filter: {connectionType: $connectionTypeFilter, isCertified: $isCertifiedFilter, isEmbedded: $isEmbeddedFilter, hasActiveWarning: $hasActiveWarningFilter, text: $textSearch}) {
    totalCount
  }
}

`;
